import { DASHBOARD_DOMAIN, DASHBOARD_PATHS } from './route-constants';
import { WHAT_TO_DO_TODAY_GUIDED_EXPERIENCE_PARAM } from './views/DashboardDesktopView/components/WhatToDoToday/constants';

export const POST_TERMS_DASHBOARD_PATH = `/${DASHBOARD_DOMAIN}${DASHBOARD_PATHS.home}?comingFrom=onboarding&${WHAT_TO_DO_TODAY_GUIDED_EXPERIENCE_PARAM}=true`;

export const isPostTermsDashboardEntry = (search: string) => {
  const params = new URLSearchParams(search);
  return (
    params.get('comingFrom') === 'onboarding' &&
    params.get(WHAT_TO_DO_TODAY_GUIDED_EXPERIENCE_PARAM) === 'true'
  );
};

export const consumePostTermsDashboardEntry = (search: string) => {
  const params = new URLSearchParams(search);
  params.delete('comingFrom');
  params.delete(WHAT_TO_DO_TODAY_GUIDED_EXPERIENCE_PARAM);
  const next = params.toString();
  return next ? `?${next}` : '';
};
